export default function TermsPage() {
  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell readable docs">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> Legal
        </p>
        <h2 className="section-title">Terms of use</h2>
        <p className="section-lead left">Last updated: 11 Sep 2026</p>

        <article className="docs-block">
          <h3>Informational site</h3>
          <p>
            Stonksindex provides information about an on-chain index token and
            related basket mechanics. Nothing on this site is an offer to sell
            securities, investment advice, or a recommendation to buy or sell
            any asset.
          </p>
        </article>

        <article className="docs-block">
          <h3>On-chain risk</h3>
          <p>
            Tokens referenced here are cryptoassets that may be extremely
            volatile, illiquid, or worthless. Smart contract, oracle, bridge,
            and key-management risks apply. You are solely responsible for your
            wallets and transactions.
          </p>
        </article>

        <article className="docs-block">
          <h3>No custody</h3>
          <p>
            We do not custody user funds through this website. Portfolio lookups
            read public chain data. Trading happens on third-party venues (e.g.
            StonkFun, Jupiter) under their terms.
          </p>
        </article>

        <article className="docs-block">
          <h3>Availability</h3>
          <p>
            The site, APIs, and worker may be unavailable, delayed, or
            inaccurate. Basket composition and payouts can change without notice.
          </p>
        </article>

        <article className="docs-block">
          <h3>Contact</h3>
          <p>
            For protocol questions, use the project&apos;s public social channels.
            Do not send assets to addresses published solely for demonstration.
          </p>
        </article>
      </div>
    </section>
  );
}
